import React from "react";

function AvailabilityReport({ availabilityReport }) {
  return (
    <div>
      <table className="min-w-full overflow-y-visible bg-white  border-gray-200 rounded-md">
        {/* Table Head  */}
        <thead>
          <tr className="bg-gray-100 ">
            <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor rounded-l-xl">
              Sl No.
            </th>
            <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor ">
              Building Name
            </th>
            <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor ">
              Total Floors
            </th>
            <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor ">
              Total Rooms
            </th>
            <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor ">
              Total Beds
            </th>
            <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor ">
              Vacant Beds
            </th>
            <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor ">
              Occupied Beds
            </th>
            <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor rounded-r-xl">
              Beds on Notice
            </th>
          </tr>
        </thead>

        {/* Table Body  */}
        <tbody>
          {availabilityReport?.length > 0 ? (
            availabilityReport?.map((data, index) => (
              <tr
                key={index}
                className="border-b border-gray-200 hover:bg-gray-50"
              >
                <td className="py-4 px-6 ext-sm text-primaryTextColor">
                  {index + 1}
                </td>

                <td className="py-4 px-6 ext-sm text-primaryTextColor">
                  {data.nameBuilding}
                </td>

                <td className="py-4 px-6 ext-sm text-primaryTextColor">
                  {data.totalFloors}
                </td>

                <td className="py-4 px-6 ext-sm text-primaryTextColor">
                  {data.totalRooms}
                </td>

                <td className="py-4 px-6 ext-sm text-primaryTextColor">
                  {data.totalBeds}
                </td>

                <td className="py-4 px-6 ext-sm text-primaryTextColor">
                  {data.vacantBeds}
                </td>

                <td className="py-4 px-6 ext-sm text-primaryTextColor">
                  {data.occupiedBeds}
                </td>

                <td className="py-4 px-6 ext-sm text-primaryTextColor">
                  {data.bedsOnNotice}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td
                colSpan="8"
                className="py-40 px-6 text-lg text-center text-secondaryTextColor"
              >
                No Data available
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default AvailabilityReport;
